import { AlertCircle } from "lucide-react";
import { useShell } from "@/components/Shell";
import { Card } from "@/components/ui/Card";
import { Button } from "@/components/ui/Button";
import { HeaderStrip } from "./HeaderStrip";
import { HealthCard } from "./HealthCard";
import { ContentGapsCard } from "./ContentGapsCard";
import { RecentConversationsCard } from "./RecentConversationsCard";
import { BotConfigCard } from "./BotConfigCard";

export function Home() {
  const { error, refresh, loading, home } = useShell();

  return (
    <div className="space-y-6">
      <HeaderStrip />

      {error && !home && (
        <Card className="border-danger/30">
          <div className="flex items-start gap-3 px-5 py-4">
            <AlertCircle size={18} strokeWidth={1.75} className="mt-0.5 shrink-0 text-danger" />
            <div className="flex-1">
              <p className="text-sm font-medium text-text-strong">Couldn't load your dashboard</p>
              <p className="mt-1 text-xs text-text-soft">{error}</p>
            </div>
            <Button variant="secondary" size="sm" onClick={() => void refresh()} loading={loading}>
              Try again
            </Button>
          </div>
        </Card>
      )}

      <HealthCard />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <ContentGapsCard />
        </div>
        <div className="lg:col-span-2">
          <RecentConversationsCard />
        </div>
      </div>

      <BotConfigCard />
    </div>
  );
}
